import React from 'react';

interface FilterSelectProps {
  icon: React.ElementType;
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string }[];
  label?: string;
}

const FilterSelect: React.FC<FilterSelectProps> = ({ 
  icon: Icon, 
  value, 
  onChange, 
  options,
  label
}) => (
  <div className="relative w-full">
    {label && (
      <label className="block text-xs sm:text-sm text-gray-400 mb-1 sm:mb-2 pl-1">
        {label}
      </label>
    )}
    <div className="relative">
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-10 sm:px-12 py-2.5 sm:py-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-white focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm sm:text-base appearance-none truncate"
        aria-label={label}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value} className="bg-[#1a1a3a] py-1 px-2">
            {option.label}
          </option>
        ))}
      </select>
      <Icon className="absolute left-3 sm:left-4 top-1/2 transform -translate-y-1/2 w-4 h-4 sm:w-5 sm:h-5 text-orange-500 pointer-events-none" />
      <div className="absolute right-3 sm:right-4 top-1/2 transform -translate-y-1/2 w-2 h-2 sm:w-2.5 sm:h-2.5 border-r-2 border-b-2 border-white rotate-45 pointer-events-none"></div>
    </div>
  </div>
);

export default FilterSelect;